
    import './styles.scoped.css';
    export default {
  "selectable-item": "awsui_selectable-item_15o6u_1ea4r_93",
  "pad-bottom": "awsui_pad-bottom_15o6u_1ea4r_115",
  "has-background": "awsui_has-background_15o6u_1ea4r_124",
  "highlighted": "awsui_highlighted_15o6u_1ea4r_127",
  "selected": "awsui_selected_15o6u_1ea4r_127",
  "disabled": "awsui_disabled_15o6u_1ea4r_141",
  "next-item-selected": "awsui_next-item-selected_15o6u_1ea4r_151",
  "is-keyboard": "awsui_is-keyboard_15o6u_1ea4r_163",
  "parent": "awsui_parent_15o6u_1ea4r_167",
  "interactiveGroups": "awsui_interactiveGroups_15o6u_1ea4r_171",
  "child": "awsui_child_15o6u_1ea4r_186",
  "virtual": "awsui_virtual_15o6u_1ea4r_201",
  "measure-strut": "awsui_measure-strut_15o6u_1ea4r_212",
  "measure-strut-first": "awsui_measure-strut-first_15o6u_1ea4r_221",
  "screenreader-content": "awsui_screenreader-content_15o6u_1ea4r_225",
  "option-content": "awsui_option-content_15o6u_1ea4r_231"
};
  